import { baseUrl, forgerockErrors } from "../../utilities/configurations";
import { useMyAccountContext } from "../../Contexts/MyAccountContext";
import { FRAuth, StepType, UserManager } from "@forgerock/javascript-sdk";
import { KeyboardArrowLeft } from "@mui/icons-material";
import NumberField from "../../Components/NumberField";
import InputField from "../../Components/InputField";
import { useAuth } from "../../Contexts/AuthContext";
import ErrorModal from "../../Components/ErrorModal";
import apiRequest from "../../utilities/request";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import React, { useEffect } from "react";
import {
  validateMobileNumber,
  validateEmail,
  startJourney,
} from "../../utilities/helper";
import {
  server_error_message,
  server_error_title,
} from "../../utilities/values";

function Details() {
  const {
    formatMobileNumber,
    setConfigRestarted,
    setDisplayAlert,
    setAlertMessage,
    setJourneyStep,
    setAlertTitle,
    isMobileValid,
    setIsLoading,
    mobileNumber,
    isEmailValid,
    displayAlert,
    alertMessage,
    handleBack,
    alertTitle,
    isLoading,
    navigate,
    setEmail,
    email,
    type,
  } = useMyAccountContext();

  const { setUser } = useAuth();

  useEffect(() => {
    if (type === "") {
      navigate("/my-account", { replace: true });
    }
  }, [type]);

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
  };

  const handleNext = async () => {
    let isValid = false;
    let message = "";
    if (type === "mobile number") {
      isValid = validateMobileNumber(`+63${mobileNumber}`);
      message = "Oops! That doesn't look like a valid number. Please check and enter valid one";
    } else if (type === "email address") {
      isValid = validateEmail(email);
      message = "Oops! That doesn't look like a valid email address. Please check and enter valid one";
    }

    if (!isValid) {
      setAlertMessage(message);
    } else {
      setIsLoading(true);
      initUpdateDetails();
    }
  };

  const initUpdateDetails = async () => {
    startJourney(process.env.REACT_APP_JOURNEY_UPDATE_USER_PROFILE);
    setJourneyStep(null);
    try {
      const initialStep = await FRAuth.start({
        query: {
          ForceAuth: true,
        },
      });
      setJourneyStep(initialStep);
      selectOption(initialStep);
    } catch (err) {
      setIsLoading(false);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      setConfigRestarted(true);
      console.log(err);
    }
  };

  const selectOption = async (step) => {
    let option = "";
    if (type === "mobile number") {
      option = "MobileNumber";
    } else if (type === "email address") {
      option = "Email";
    }

    if (option) {
      try {
        let journey_obj = JSON.parse(JSON.stringify(step));
        journey_obj.callbacks[0].payload.input[0].value = option;
        journey_obj.payload.callbacks[0].input[0].value = option;

        const nextStep = await FRAuth.next(journey_obj);
        switch (nextStep.type) {
          case StepType.Step:
            setJourneyStep(nextStep);
            proceedNext(nextStep);
            break;
          case StepType.LoginFailure:
            {
              const detail = nextStep.getDetail();
              const errorReason = nextStep.getReason();
              const errorMessage = nextStep.getMessage();
              if (detail?.errorCode === "110") {
                setDisplayAlert(true);
                setAlertTitle(errorReason);
                setAlertMessage(errorMessage);
              } else {
                setAlertMessage(
                  forgerockErrors[detail?.failureUrl] ||
                    "Something went wrong. Please try again."
                );
              }
              setIsLoading(false);
              setConfigRestarted(true);
            }
            break;
        }
      } catch (err) {
        setIsLoading(false);
        setConfigRestarted(true);
        setDisplayAlert(true);
        setAlertTitle(server_error_title);
        setAlertMessage(server_error_message);
        console.log(err);
      }
    }
  };

  const proceedNext = async (step) => {
    let value = "";
    if (type === "mobile number") {
      value = `+63${mobileNumber}`;
    } else if (type === "email address") {
      value = email;
    }
    try {
      let journey_obj = JSON.parse(JSON.stringify(step));
      journey_obj.callbacks[0].payload.input[0].value = value;
      journey_obj.payload.callbacks[0].input[0].value = value;

      const nextStep = await FRAuth.next(journey_obj);
      switch (nextStep.type) {
        case StepType.Step:
          setJourneyStep(nextStep);
          if (type === "mobile number") {
            navigate("/my-account/update-details/otp");
            setIsLoading(false);
          } else {
            sendEmail(nextStep);
          }
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] || forgerockErrors["SWW"]
              );
            }
            setIsLoading(false);
            setConfigRestarted(true);
          }
          break;
      }
    } catch (err) {
      setIsLoading(false);
      setConfigRestarted(true);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
    }
  };

  const sendEmail = async (step) => {
    let token = step.callbacks[0].payload.output[0].value;
    try {
      const res = await apiRequest(baseUrl + "/verify-email", "POST", {
        email: email,
        token: token,
      });
      if (!res.error) {
        navigate("/my-account/update-details/success");
        const fr_user = await UserManager.getCurrentUser();
        if (fr_user) {
          setUser(fr_user);
        }
      } else {
        setConfigRestarted(true);
        setDisplayAlert(true);
        setAlertTitle("Error");
        setAlertMessage("Error encountered in sending verification email.");
        console.log(res.message);
      }
    } catch (err) {
      setConfigRestarted(true);
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
  };

  let content = null;
  if (type === "email address") {
    content = (
      <React.Fragment>
        <div className="text-[#1F2328] text-xl font-bold mb-1">
          Enter a new email address
        </div>
        <div className="text-[#60656D] mb-4">
          You will receive an OTP via email when you continue
        </div>
        <InputField
          id="email"
          maxLength="50"
          placeholder="example@email.com"
          value={email}
          onChange={handleChangeEmail}
          error={!displayAlert && alertMessage}
          helperText={!displayAlert ? alertMessage : ""}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              if (isLoading === false) {
                handleNext();
              }
            }
          }}
        />
      </React.Fragment>
    );
  } else {
    content = (
      <React.Fragment>
        <p className="text-[#1F2328] text-xl font-bold mb-1">
          Enter a new mobile number
        </p>
        <p className="text-[#60656D] mb-4">
          You will receive an OTP via SMS when you continue
        </p>
        <NumberField
          id="mobileNumber"
          type="text"
          adornment="+63"
          value={mobileNumber}
          onChange={formatMobileNumber}
          onKeyUp={(e) => {
            if (
              e.key === "Enter" &&
              mobileNumber.length === 10 &&
              isLoading === false
            ) {
              handleNext();
            }
          }}
          error={!displayAlert && alertMessage}
          helperText={!displayAlert ? alertMessage : ""}
        />
      </React.Fragment>
    );
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full flex flex-row items-center p-4 border-b">
          <button onClick={handleBack}>
            <KeyboardArrowLeft />
          </button>
          <div className="text-center text-md font-bold flex-1">
            Edit {type}
          </div>
          <button disabled className="invisible">
            <KeyboardArrowLeft />
          </button>
        </div>
        <div className="p-4 w-full">{content}</div>
        <div className="flex w-full p-4 mt-auto">
          <Button
            disabled={
              (type === "email address" ? !isEmailValid : !isMobileValid) ||
              isLoading
            }
            className={`h-12 w-full rounded-xl ${
              (type === "email address" ? !isEmailValid : !isMobileValid) ||
              isLoading
                ? "bg-[#F6F7F7] text-[#A3A7AB]"
                : "text-white"
            }`}
            onClick={() => handleNext()}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
          </Button>
        </div>
      </div>
      <ErrorModal
        open={displayAlert}
        title={alertTitle}
        message={alertMessage}
        onClose={handleClose}
      />
    </div>
  );
}

export default Details;
